/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { FxGamesLibWebRpcContractsResponseError } from './FxGamesLibWebRpcContractsResponseError';
import {
    instanceOfFxGamesLibWebRpcContractsResponseError,
    FxGamesLibWebRpcContractsResponseErrorFromJSON,
    FxGamesLibWebRpcContractsResponseErrorFromJSONTyped,
    FxGamesLibWebRpcContractsResponseErrorToJSON,
} from './FxGamesLibWebRpcContractsResponseError';

/**
 * @type FxGamesLibWebRpcContractsResponseResponseError
 * 
 * @export
 */
export type FxGamesLibWebRpcContractsResponseResponseError = FxGamesLibWebRpcContractsResponseError;

export function FxGamesLibWebRpcContractsResponseResponseErrorFromJSON(json: any): FxGamesLibWebRpcContractsResponseResponseError {
    return FxGamesLibWebRpcContractsResponseResponseErrorFromJSONTyped(json, false);
}

export function FxGamesLibWebRpcContractsResponseResponseErrorFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxGamesLibWebRpcContractsResponseResponseError {
    if (json == null) {
        return json;
    }
    if (instanceOfFxGamesLibWebRpcContractsResponseError(json)) {
        return FxGamesLibWebRpcContractsResponseErrorFromJSONTyped(json, true);
    }

    return {} as any;
}

export function FxGamesLibWebRpcContractsResponseResponseErrorToJSON(json: any): any {
    return FxGamesLibWebRpcContractsResponseResponseErrorToJSONTyped(json, false);
}

export function FxGamesLibWebRpcContractsResponseResponseErrorToJSONTyped(value?: FxGamesLibWebRpcContractsResponseResponseError | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    if (instanceOfFxGamesLibWebRpcContractsResponseError(value)) {
        return FxGamesLibWebRpcContractsResponseErrorToJSON(value as FxGamesLibWebRpcContractsResponseError);
    }

    return {};
}

